import { Component, OnInit, Input } from '@angular/core';
import { IssuePriorityFront } from '../../../models/api.models';

@Component({
  selector: 'app-issue-priority-chip',
  templateUrl: './issue-priority-chip.component.html',
  styleUrls: ['./issue-priority-chip.component.scss'],
})
export class IssuePriorityChipComponent implements OnInit {

  @Input() issuePriority: IssuePriorityFront = new IssuePriorityFront();

  constructor() { }

  ngOnInit() {}

}
